__turbopack_context__.v({
  "checkbox": "Checkbox-module__zFEviq__checkbox",
  "error": "Checkbox-module__zFEviq__error",
  "errorMessage": "Checkbox-module__zFEviq__errorMessage",
  "errorMessageContainer": "Checkbox-module__zFEviq__errorMessageContainer",
  "wrapper": "Checkbox-module__zFEviq__wrapper",
});
